module.exports = __webpack_public_path__ + "static/media/discord.cf773058.jpg";